import Calendar from 'react-calendar'
import styled, { css } from 'styled-components'
import { theme } from '@alefeducation/ui-elements-library-core'

export const DatePickerWrapper = styled.div<{ x?: number; y?: number }>`
  top: ${props => props.y}px;
  left: ${props => props.x}px;
  z-index: 10000;
  position: fixed;
  display: flex;
  width: 368px;
  padding: 16px 1px 40px 1px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  border-radius: 10px;
  border: 1px solid #dadde0;
  background: #fff;
  box-shadow: 0px 6px 14px 0px rgba(72, 84, 101, 0.15);
  .date-picker-close-icon {
    text-align: right;
    padding: 0 15px;
    width: 100%;
  }
  .date-picker-buttons {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 20px;
    justify-content: center;
    padding-top: 24px;
    border-top: 1px solid ${theme.colors.primary[20]};
  }
`

export const StyledCalendar = styled(Calendar)`
  padding: 0 40px;
  &:before,
  &:after {
    bottom: 100%;
    left: unset;
    right: 10%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &:after {
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: white;
    border-width: 8px;
    margin-left: unset;
    margin-right: -8px;
  }

  &:before {
    border-color: rgba(61, 70, 77, 0);
    border-bottom-color: ${props => props.theme.colors.primary[40]};
    border-width: 9px;
    margin-left: unset;
    margin-right: -9px;
  }

  button {
    background-color: white;
    border-radius: unset;
    padding: unset;
    font-family: Signika, serif !important;
    font-weight: 400;
    line-height: 1.5;
  }

  button:disabled {
    opacity: 1;
  }

  .react-calendar {
    &__tile--active > abbr {
      background-color: ${props => props.theme.colors.interactive[30]} !important;
      color: ${props => props.theme.colors.interactive[120]} !important;
    }

    &__navigation {
      display: flex;
      justify-content: space-between;
      position: relative;
      margin-bottom: 8px;
      padding: 0 14px;
    }

    &__navigation__label,
    &__month-view__weekdays {
      font-family: Signika;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      border: none;
      text-align: left;
      color: ${props => props.theme.colors.text100};
      &__labelText {
        word-spacing: 16px;
      }
    }
    &__navigation__prev-button,
    &__navigation__next-button {
      padding: 0 !important;
      width: 32px;
      height: 32px;
      position: absolute;
      border: none;
      top: -4px;
    }

    &__navigation__prev-button {
      right: 40px;
    }

    &__navigation__prev-button:disabled > svg {
      color: ${props => props.theme.colors.primary[10]};
    }

    &__navigation__next-button {
      right: 4px;
    }

    &__month-view__weekdays {
      padding: 4px 0;
      abbr {
        text-decoration: unset;
      }

      &__weekday {
        text-align: center;
      }
    }

    &__month-view__days {
      button:disabled > abbr {
        color: ${props => props.theme.colors.primary[20]};
        border: 0;
      }

      &__day > abbr:hover {
        border: 1px solid ${props => props.theme.colors.interactive[100]};
      }

      &__day {
        height: 32px;
        width: 32px !important;
        font-size: 14px;
        font-weight: 100;
        display: flex;
        justify-content: center;
        align-items: center;
        border: none;
        > abbr {
          height: 32px;
          width: 32px !important;
          border-radius: 100% !important;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: Signika;
          font-size: 16px;
          font-style: normal;
          font-weight: 300 !important;
          line-height: normal;
          color: ${props => props.theme.colors.text100};
        }

        &--neighboringMonth > abbr {
          color: ${props => props.theme.colors.primary[20]};
        }
      }
    }
  }
`

export const StyledDateButton = styled.div<{ disabled: boolean }>`
  width: calc(100% - 1px);
  justify-content: flex-start;
  height: 36px;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  gap: 4px;
  border-radius: 8px;
  align-items: center;
  cursor: ${props => (props.onClick ? 'pointer' : 'default')};
  > div {
    display: flex;
    gap: 8px;
    width: 100%;
    justify-content: flex-start;
    align-items: flex-end;
  }

  ${props =>
    props.disabled
      ? css`
          :active,
          :hover,
          :focus {
            box-shadow: rgb(182, 187, 193) 0px 0px 0px 1px;
          }
        `
      : ''};
`
